export enum DisplayType {
  Default = 0,
  Custom = 1,
  Miles = 2,
  DateLocal = 3,
  DateUtc = 4,
  Name = 5,
  ShortString = 6,
  Money = 7,
  Enum = 8,
  Rate = 9,
  Number = 10,
  TimeLength = 11,
  Fuel = 12,
  Percentage = 13,
  MPG = 14,
  Boolean = 15,
  DateTimeLocal = 16,
  DateTimeUtc = 17,
  ShortStringArray = 18,
  PercentageFromWholeNumber = 19,
  ShortStringArrayWithParameter = 20,
  CalendarDateUtc = 21,
  Array = 22,
  TimeUtc = 23,
  Time = 24,
  ScheduleTime = 25,
  HTML = 26,
  Duration = 27,
  FormattedText = 28,
  ShortStringArrayFT = 29,
  ShortStringArrayWithParameterFT = 30,
  //GetTextLabel=32,

  Digits3 = 32,
  Hidden = 33,

  DateTimeSecLocal = 34,
  DateTimeSecUtc = 35,
  Float = 36,
  Double = 37,
  Financial = 38,
  EnumArray = 39
}

export const DisplayTypeSingleLine: DisplayType[] = [
  DisplayType.Boolean,
  DisplayType.Money,
  DisplayType.Rate,
  DisplayType.Percentage,
  DisplayType.MPG,
  DisplayType.Fuel,
  DisplayType.Number,
  DisplayType.Float,
  DisplayType.Double,
  DisplayType.Financial
];
